export default {
    roomCall: {
        callType: 'p2p',
        isEmptyLayoutType: '',
        videoLayout: '',
        webinarType: 'none',
        mixingLayoutData: {},
        videoQuality:'',
        requestUnmute: false,
        userGestureInit: false,
    },

    showConnectionStats: false,
    showConnectionStatsWindow: false,
    mixerConnectionStats: null,

    userConnectionStats: {},
}
